<template lang="pug">
.switchsite
  h2 Head straight to one of our services
  nav: ul
    li(v-for="it in items")
      a(:href="it.link")
        h3 KEZZLER
          |
          span.ml5(:class="it.subtitleClass") {{it.subtitle}}
        p {{it.description}}
</template>
<script>
const items = [{
  link: '#/core',
  subtitle: 'Core',
  subtitleClass: 'light-grey',
  description: 'Kezzler SSP Core - Serialization Service Platform Core'
}, {
  link: '#/activator',
  subtitle: 'Activate',
  subtitleClass: 'green',
  description: 'Roll Activator'
}, {
  link: '#/trackntrace',
  subtitle: 'Track&Trace',
  subtitleClass: 'yellow',
  description: 'Track and Trace Solution'
}]
export default {
  data: () => ({
    items
  })
}
</script>



// WEBPACK FOOTER //
// src/components/nav/Switchsite.vue